import { useRoom } from "../contexts/RoomContext.jsx";
import { STOP_CATEGORIES } from "../data/stopCategories.js";

export function StopRoundResultPage() {
  const { roomData, isHost, nextRound } = useRoom();
  const players = Object.values(roomData?.players || {});
  const results = roomData?.stopResultadoRodada || {};
  const letter = roomData?.stopLetraAtual || "";
  const ranking = [...players].sort(
    (first, second) =>
      (results[second.id]?.pontos || 0) - (results[first.id]?.pontos || 0),
  );

  return (
    <div className="container-sm stop-result-page">
      <header className="text-center stop-result-heading">
        <h2 className="title">📊 Resultado da Rodada</h2>
        <p className="subtitle">
          Letra <strong>{letter}</strong> — veja quanto cada um pontuou:
        </p>
      </header>
      {ranking.map((player, index) => {
        const result = results[player.id] || { pontos: 0, detalhes: {} };
        return (
          <article className="card stop-player-result" key={player.id}>
            <header>
              <h3 className="section-title">
                {index === 0 && result.pontos > 0 && "🥇 "}
                {player.username} {player.isHost && "👑"}
              </h3>
              <span className="player-points">+{result.pontos} pts</span>
            </header>
            <div className="stop-result-answers">
              {STOP_CATEGORIES.map((category) => {
                const detail = result.detalhes?.[category.id];
                const answer = detail?.texto || "";
                const valid = Boolean(detail?.valida);
                return (
                  <div key={category.id}>
                    <span title={category.descricao || category.label}>
                      {category.emoji} {category.label}
                    </span>
                    <span className={answer ? "" : "empty"}>
                      {answer || "em branco"}
                    </span>
                    <strong
                      className={valid ? "valid" : "invalid"}
                      title={
                        detail?.repetida
                          ? "Resposta repetida: metade dos pontos"
                          : undefined
                      }
                    >
                      {valid
                        ? `+${detail.pontos}${detail.repetida ? " · repetida" : ""}`
                        : "0"}
                    </strong>
                  </div>
                );
              })}
            </div>
          </article>
        );
      })}
      <div className="mt-40 text-center">
        {isHost ? (
          <button className="btn btn-primary" onClick={nextRound} type="button">
            Próxima Rodada ➔
          </button>
        ) : (
          <p className="info-box">
            Aguardando o host avançar pra próxima rodada...
          </p>
        )}
      </div>
    </div>
  );
}
